import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BACKEND_URL } from '../utils/api';
import { setToken } from '../utils/session';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state') || '/';

    if (code) {
      fetch(`${BACKEND_URL}/api/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, redirect_uri: `${window.location.origin}/auth/callback` }),
      })
        .then(r => { if (!r.ok) throw new Error('Auth failed'); return r.json(); })
        .then(data => {
          if (data.session_token) setToken(data.session_token);
          navigate(state, { state: { user: data } });
        })
        .catch(() => navigate('/'));
      return;
    }

    // Legacy Emergent Auth
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (match) {
      fetch(`${BACKEND_URL}/api/auth/session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: match[1] }),
      })
        .then(r => { if (!r.ok) throw new Error(); return r.json(); })
        .then(data => {
          if (data.session_token) setToken(data.session_token);
          navigate(state, { state: { user: data } });
        })
        .catch(() => navigate('/'));
      return;
    }

    navigate('/');
  }, [navigate, searchParams]);

  return <div className="min-h-dvh flex items-center justify-center"><p className="text-muted-foreground text-sm">Autenticando...</p></div>;
};

export default AuthCallback;
